import { getSelectMessage } from '../../../../utils/formValidation/errorMessageFunctions';

import { validateNotes } from './commonFunctions';

export const ERROR_ID = 'Entry cannot be updated without an ID';

export const validate = (newEntry) => {
    let newErrors = {};

    if (!newEntry.id) {
        newErrors = {
            ...newErrors,
            id: { error: true, message: ERROR_ID }
        };
    }

    if (!newEntry.statusId) {
        newErrors = {
            ...newErrors,
            statusId: { error: true, message: getSelectMessage('DAR status') }
        };
    }
    
    newErrors = validateNotes(newEntry.notes, newErrors);

    return newErrors;
};